import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69bd92d67d947e0014e4882f/nexsys/src/app/news/page.tsx");
